import { render } from "./Typography.vue?vue&type=template&id=4a2f47f3&scoped=true"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"

import "./Typography.vue?vue&type=style&index=0&id=4a2f47f3&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\ilustranext\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a2f47f3"]])

export default __exports__